<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<mat-card class="feedback-questions-content-item" *ngIf="answer">
  <div class="item-headline">
    <div class="title" [innerHTML]="title"></div>

    <div class="responses-count">
      {{ 'translations.diagnostics.labels.feedbackAdditionalContentResponses' | transloco: { number: feedbackProviderResponsesCount } }}
    </div>
  </div>

  <ul class="answers-list">
    @if (feedbackRecipient && answer.learnerQuestionAnswer) {
      <li class="answer-item">
        <div class="answer-meta">
          <div class="avatar" *ngIf="feedbackRecipient?.imageUrl">
            <img [src]="feedbackRecipient?.imageUrl" alt="{{ feedbackRecipient?.firstName }}" />
          </div>

          <div class="provider">
            <div class="provider-name medium bold">{{ feedbackRecipient?.firstName }} {{ feedbackRecipient?.lastName }}</div>
          </div>

          <span class="section-label">SELF-RATING</span>
        </div>

        <div class="answer-body">
          <ptl-resource-preview
            *ngIf="answer.learnerQuestionAnswer?.richTextAnswer?.length"
            [previewContent]="answer.learnerQuestionAnswer?.richTextAnswer"
          ></ptl-resource-preview>
        </div>
      </li>
    }
    <li class="answer-item" *ngFor="let item of answer.answers; let i = index">
      <div class="answer-meta">
        <div class="avatar" *ngIf="item.providerImage">
          <img [src]="item.providerImage" alt="{{ item.providerName }}" />
        </div>

        <div class="provider">
          <div class="provider-name medium bold">{{ item.providerName }}</div>
        </div>
      </div>

      <div class="answer-body">
        <ptl-resource-preview *ngIf="item?.richText?.length" [previewContent]="item?.richText"></ptl-resource-preview>
      </div>
    </li>
  </ul>
</mat-card>
